module.exports = __webpack_public_path__ + "assets/7ad34df3d108e80e4f31d382d3346ba9.mp3";